import React, {useEffect, useState} from 'react'
import {Grid, Segment, Icon, Label, Form, List, Header, Button, Image, Loader, Dimmer} from "semantic-ui-react";
import Axios from "axios";
import objDefault from '../../../models/basketModel'
import Constants from "../../../config/constants";
import FileBase64 from 'react-file-base64';
import {useHistory} from "react-router-dom";

const Basket = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [inputText, setInputText] = useState({
        text_head: 'เกิดข้อผิดพลาด',
        text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
        text_error: [],
        detail: false,
    });
    const history = useHistory()
    const [basket, setBasket] = useState([]);

    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;

        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,

        }))

    };


    const handleValidate = () => {
        setInputText((prevInput) => ({
            ...prevInput,
            detail: !!!input.detail ? 'require' : false,
        }))

    }

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('admission_id')
        const patient_id = params.get('patient_id')
        setInput((prevInput) => ({
            ...prevInput,
            admission_id: id,
            patient_id: patient_id
        }))
        getPictureList(id)


    }, [inputText]);


    function openInNewTab(path) {
        var win = window.open(path, '_blank');
        win.focus();
    }

    const navigateTo = (id, path) => {
        history.push(path + id);


    }


    const getFiles = (e, name) => {
        setInput((prevInput) => ({
            ...prevInput,
            [name]: e.base64
        }))
    }

    const getPictureById = async (id) => {
        setInput((prevInput) => ({
            ...prevInput,
            active: true
        }))
        let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission-file-id?id=' + id, {
            headers: {
                Authorization: Constants.headerAuthorization,
                'Content-Type': 'application/json'
            }
        });
        response = response.data.data[0]

        setInput((prevInput) => ({
            ...prevInput,
            patient_id: response.patient_id,
            admission_id: response.admission_id,
            id: response.id,
            detail: response.detail,
            img_path: response.img_path,
            active: false
        }))

    }

    const getPictureList = async (id) => {
        let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission-file-list?admission_id=' + id, {
            headers: {
                Authorization: Constants.headerAuthorization,
                'Content-Type': 'application/json'
            }
        });
        setBasket(response.data.data)
    }

    const savePicture = async (e) => {
        await handleValidate()
        try {
            setInput((prevInput) => ({
                ...prevInput,
                active: true
            }))
            if (input.detail !== undefined) {
                let result = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission-file',
                    {
                        img_path: input.img_path,
                        detail: input.detail,
                        admission_id: input.admission_id,
                        patient_id: input.patient_id,
                        id: input.id
                    }, {
                        headers: {
                            Authorization: Constants.headerAuthorization,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (input.id) {
                    alert('แก้ไขสำเร็จ')
                } else {
                    alert('บันทึกสำเร็จ')
                }
                getPictureList(input.admission_id)
                setInput((prevInput) => ({
                    ...prevInput,
                    active: false
                }))
            }
        } catch (e) {

        }

    }


    return (
        <div>


            <div>
                <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                    {
                        input.admission_id ?
                            <>

                                <Grid.Row>
                                    <Grid.Column width={10}>
                                        <Segment color='teal' raised>
                                            <Header as='h3' dividing>

                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/admission?id=')}
                                                        key={input.admission_id}>
                                                    <Icon name={'file alternate outline'}></Icon> Admission note
                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/discharge?admission_id=')}
                                                        key={input.admission_id}>
                                                    <Icon name={'file alternate outline'}></Icon> Discharge summary

                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/opnote?admission_id=')}
                                                        key={input.admission_id}>
                                                    <Icon name={'plus'}></Icon>new Operation note
                                                </Button>
                                                <Button color='grey' disabled={true}>
                                                    <Icon name={'image'}></Icon>Picture basket
                                                </Button>

                                            </Header>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </>
                            : ''
                    }
                    <Grid.Row>
                        <Dimmer active={input.active} inverted><Loader size='large'>Loading</Loader></Dimmer>
                        <Grid.Column width={3}>
                            <Segment color='teal' raised>
                                <Label>
                                    <Icon name='wordpress forms'/> รายการ image basket
                                </Label>


                                <List divided relaxed>
                                    {

                                        basket.length > 0 ? basket.map((user, index) => (

                                            <List.Item key={user.id}>
                                                # {index + 1} <label><Icon name='image outline' color={"teal"}
                                                                           style={{cursor: 'pointer'}}
                                                                           onClick={() => openInNewTab(user.img_path)}/></label>
                                                <List.Icon name='user circle' size='large' verticalAlign='middle'/>
                                                <List.Content
                                                    onClick={(e) => getPictureById(user.id)}
                                                >
                                                    <List.Header as='a'>{user.name} HN :{user.hn}</List.Header>
                                                    <List.Description as='a'>detail
                                                        :{user.detail.substring(0, 30) + '...'}</List.Description>
                                                </List.Content>
                                            </List.Item>
                                        )) : <List.Item> <List.Content><List.Header
                                            as='a'>ไม่พบข้อมูล</List.Header></List.Content></List.Item>
                                    }
                                </List>

                            </Segment>
                        </Grid.Column>

                        <Grid.Column width={12}>

                            <Segment color='teal' raised>
                                <Form>
                                    <Header as='h3' color='blue' dividing>
                                        information
                                    </Header>
                                    <Form.Group widths='equal'>
                                        &nbsp;&nbsp;&nbsp;
                                        {input.img_path ? <Image
                                                onClick={() => openInNewTab(input.img_path)}
                                                src={input.img_path}
                                                size='small' style={{width: '50%', cursor: 'pointer'}}/> :
                                            <Image src='https://react.semantic-ui.com/images/wireframe/image.png'
                                                   size='small' style={{width: '50%'}}/>}
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <FileBase64
                                            onDone={(e) => getFiles(e, 'img_path')}
                                            name='img_path'


                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid
                                            name='detail'
                                            value={input.detail}
                                            placeholder='รายละเอียด'
                                            rows={15}
                                            onChange={(e) => handleValueChange(e)}
                                            required={true}
                                            error={inputText.detail}
                                        />
                                    </Form.Group>

                                    <Form.Button color='blue'
                                                 onClick={() => savePicture()}
                                    ><Icon name='plus'/> บันทึก Picture</Form.Button>
                                </Form>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        </div>


    );
}

export default Basket;
